import { Checkbox, Grid, MenuItem, Radio, Select, Typography, makeStyles } from '@material-ui/core';
import { CheckBoxOutlineBlank, RadioButtonUncheckedOutlined } from '@material-ui/icons';
import React, { useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Dropdown } from './Dropdown';

const useStyle = makeStyles({
  questionBox: {
    height: '68vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },
  heading: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#10182B',
  },
  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  optional_field: {
    color: '#667085',
  },
  questionWrapper: {
    marginTop: '10px',
    width: '100%',
  },
  questionTypeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '99%',
  },
  questionTypeLabel: {
    padding: '5px',
    color: 'white',
    background: '#622FEE',
    borderRadius: '4px',
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '15px',
  },
  select: {
    padding: '5px',
    marginLeft: '5px',
  },
  qeustion: {
    width: '99%',
    marginTop: '10px',
  },
  inputField: {
    width: '98%',
    padding: '20px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  optionsList: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    paddingLeft: '10px',
  },
  openListItemLable: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  optionText: {
    padding: ' 12px 10px',
    borderRadius: '4px',
    background: '#fefefe',
    width: '97%',
    border: 'none',
  },
  radioBtn: {
    color: '#622fee',
    width: '5px',
    height: '5px',
  },
  addOption: {
    color: '#622FEE',
    borderBottom: '2px solid #622FEE',
    display: 'inline',
    fontWeight: '600',
    cursor: 'pointer',
  },
});

export function AddQuestion({
  categories,
  journeys,
  guides,
  selectedJId,
  selectedGuideId,
  selectedCatId,
  setSelectedJId,
  setSelectedGuideId,
  setSelectedCatId,
  queType,
  setQueType,
  queTitle,
  setQueTitle,
  options,
  setOptions,
  isEdit,
  questions,
  selectedIndex,
  calledFrom,
  info,
}) {
  const classes = useStyle();

  useEffect(() => {
    const que = questions[selectedIndex];
    if (isEdit) {
      setQueTitle(que.title);
      setOptions(que.options);
      setQueType(que.type);
      setSelectedGuideId(que.guideId);
      setSelectedJId(que.journeyId);
      if (calledFrom !== 'collection') {
        setSelectedCatId(que.questionCategoryId);
      }
    }
  }, []);

  const handleChange = (e, indx) => {
    const temp = [...options];
    const val = e.target.value;
    if (val.length <= 255 && !(info?.questionEditRemoveWarning && temp[indx]?.id)) {
      temp[indx].title = val;
    }

    setOptions(temp);
  };

  const handleSelect = (indx) => {
    if (!isEditable()) {
      return;
    }
    if (queType === 'single_select') {
      setOptions((prevOptions) =>
        prevOptions.map((option, i) => {
          if (i === indx) {
            return { ...option, isAnswer: true };
          }
          return { ...option, isAnswer: false };
        }),
      );
    } else {
      const temp = [...options];
      temp[indx].isAnswer = !temp[indx].isAnswer;
      setOptions(temp);
    }
  };

  const handleAddOption = () => {
    setOptions((prevOptions) => [
      ...prevOptions,
      {
        title: '',
        isAnswer: false,
      },
    ]);
  };

  const handleRemoveOption = (indx) => {
    const temp = [...options];
    temp.splice(indx, 1);
    setOptions(temp);
  };

  const handleQueTypeChange = (type) => {
    if (!isEditable()) {
      return;
    }
    if (type === 'single_select' && queType === 'multi_select') {
      const countCorrectAnswers = options.filter((op) => op.isAnswer).length;
      if (countCorrectAnswers === 1) {
        setQueType(type);
        return;
      }
      const temp = options.map((op) => ({ ...op, isAnswer: false }));
      setOptions(temp);
    }
    setQueType(type);
  };

  const handleSelectJid = (id) => {
    if (isEditable()) {
      setSelectedJId(id);
    }
  };

  const handleSelectGid = (id) => {
    if (isEditable()) {
      setSelectedGuideId(id);
    }
  };

  const isEditable = () => {
    if (isEdit && info?.questionEditRemoveWarning) {
      return false;
    }
    return true;
  };

  return (
    <Grid className={classes.questionBox}>
      <Grid style={{ width: '100%' }}>
        <Grid>
          <Typography className={classes.heading}>Add Question</Typography>
        </Grid>
      </Grid>

      <Grid style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {calledFrom && calledFrom === 'collection' ? null : (
          <Grid style={{ width: '100%' }}>
            <Typography className={classes.required_field}>Category </Typography>
            <Grid style={{ padding: '0px', width: '99%', marginTop: '5px' }}>
              <Select
                fullWidth
                variant="outlined"
                style={{ height: '55px', background: '#fff' }}
                name="department"
                id="departmentId"
                displayEmpty
                value={selectedCatId}
              >
                <MenuItem
                  value=""
                  disabled
                  selected
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'left',
                    background: '#fff',
                  }}
                >
                  Select category
                </MenuItem>
                {categories?.map((cat) => (
                  <MenuItem
                    value={cat.id}
                    key={cat.id}
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'left',
                      background: '#fff',
                    }}
                    onClick={() => {
                      if (isEditable()) {
                        setSelectedCatId(cat.id);
                      }
                    }}
                  >
                    {cat.title}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        )}
        <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Grid style={{ width: '47%' }}>
            <Typography className={classes.required_field}>Journey </Typography>
            <Grid style={{ padding: '0px', width: '99%', marginTop: '5px' }}>
              <Dropdown
                data={journeys}
                selectedData={selectedJId}
                setSelectedData={handleSelectJid}
                isSearchable
                dropdownText="Select Journey"
              />
            </Grid>
          </Grid>
          <Grid style={{ width: '47%' }}>
            <Typography className={classes.optional_field}>Guide </Typography>
            <Grid style={{ padding: '0px', width: '99%', marginTop: '5px' }}>
              <Dropdown
                data={guides}
                selectedData={selectedGuideId}
                setSelectedData={handleSelectGid}
                isSearchable
                dropdownText="Select Guide"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid className={classes.questionWrapper}>
          <Grid className={classes.questionTypeContainer}>
            <Grid className={classes.questionTypeLabel}>Question</Grid>
            <Grid>
              <Grid className={classes.selectContainer}>
                <Grid item style={{ display: 'flex', gap: '10px', alignItems: 'center', width: '300px' }}>
                  <Typography style={{ width: '170px', color: '#667085' }}>Question type:</Typography>
                  <Select
                    fullWidth
                    variant="outlined"
                    style={{ height: '40px', background: '#fff', width: '230px' }}
                    name="qtype"
                    id="qtypeId"
                    displayEmpty
                    value={queType}
                  >
                    <MenuItem
                      value="single_select"
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'left',
                        background: '#fff',
                      }}
                      onClick={() => handleQueTypeChange('single_select')}
                    >
                      Single Select
                    </MenuItem>
                    <MenuItem
                      value="multi_select"
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'left',
                        background: '#fff',
                      }}
                      onClick={() => handleQueTypeChange('multi_select')}
                    >
                      Multi Select
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.qeustion}>
            <Grid style={{ position: 'relative' }}>
              <input
                placeholder="Write question here"
                className={classes.inputField}
                value={queTitle}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val.length <= 350 && isEditable()) {
                    setQueTitle(val);
                  }
                }}
              />
              <Typography
                style={{ position: 'absolute', bottom: '4px', right: '4px', color: '#667085', fontSize: '12px' }}
              >
                {queTitle?.length || 0} / 350
              </Typography>
            </Grid>

            <ul className={classes.optionsList}>
              {options?.map((op, i) => (
                <li className={classes.optionListItem}>
                  <label htmlFor="nothing" className={classes.openListItemLable}>
                    {queType === 'single_select' ? <RadioButtonUncheckedOutlined /> : <CheckBoxOutlineBlank />}
                    <Grid style={{ width: '62%', position: 'relative' }}>
                      <input
                        className={classes.optionText}
                        placeholder={`Option ${i + 1}`}
                        value={op.title}
                        onChange={(e) => handleChange(e, i)}
                      />
                      <Typography
                        style={{
                          position: 'absolute',
                          bottom: '-1px',
                          right: '1px',
                          color: '#667085',
                          fontSize: '12px',
                        }}
                      >
                        {op?.title?.length || 0} / 255
                      </Typography>
                    </Grid>

                    <Grid
                      style={{
                        width: '30%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      {queType === 'single_select' ? (
                        <Radio
                          onClick={() => handleSelect(i)}
                          className={classes.radioBtn}
                          checked={op.isAnswer}
                          style={{ ...(op.isAnswer ? { color: '#622fee' } : {}) }}
                        />
                      ) : (
                        <Checkbox
                          onClick={() => handleSelect(i)}
                          className={classes.radioBtn}
                          checked={op.isAnswer}
                          style={{ ...(op.isAnswer ? { color: '#622fee' } : {}) }}
                        />
                      )}

                      <Typography>Mark as correct answer</Typography>
                      {options?.length > 2 ? (
                        <CloseIcon style={{ cursor: 'pointer' }} onClick={() => handleRemoveOption(i)} />
                      ) : (
                        <CloseIcon style={{ visibility: 'hidden' }} />
                      )}
                    </Grid>
                  </label>
                </li>
              ))}
            </ul>
            <Typography className={classes.addOption} onClick={handleAddOption}>
              + Add option
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
